import { createRouter } from 'uni-mini-router';
import useAuthStore from '@/stores/auth';
import { useUserStore } from '@/stores/user';
// 导入pages.json
import pagesJson from '../pages.json';
// 引入uni-parse-pages
import pagesJsonToRoutes from 'uni-parse-pages';
import pinia from '@/stores/store';
import { useSystemStore } from '@/stores/system';

// 登录页路径
const loginRoutePath = '/mobile/login/index';
// 默认首页路径
const defaultRoutePath = '/mobile/workbench/home/index';
// 白名单名单路径
const whiteList = ['403', 'bindPhone', 'noTenant', 'N_1', 'P_1', 'M_2'];

// 生成路由表
const routes = pagesJsonToRoutes(pagesJson);
const router = createRouter({
    // 路由表信息
    routes: [...routes]
});

// 全局前置守卫
router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore(pinia);
    const userStore = useUserStore(pinia);
    const systemStore = useSystemStore();
    console.log(authStore.getToken, to, whiteList.indexOf(to.name as string) > -1);
    if (authStore.getToken || whiteList.indexOf(to.name as string) > -1) {
        if (to.path === loginRoutePath) {
            next({ path: defaultRoutePath });
        } else {
            console.log(userStore.getUser);
            // 获取用户数据和菜单路由数据
            if (!userStore.getUser?.userId) {
                if (authStore.getToken) {
                    await userStore.initUser();
                    await systemStore.initSystem();
                }
                if (
                    userStore.getUser?.permissions?.indexOf(to.name as string) > -1 ||
                    (to.name?.indexOf('mobile_') as number) > -1 ||
                    whiteList.indexOf(to.name as string) > -1
                ) {
                    next();
                } else {
                    next({
                        path: '/mobile/auth/index',
                        navType: 'push'
                    });
                }
            } else {
                if (
                    userStore.getUser?.permissions?.indexOf(to.name as string) > -1 ||
                    (to.name?.indexOf('mobile_') as number) > -1 ||
                    whiteList.indexOf(to.name as string) > -1
                ) {
                    next();
                } else {
                    next({
                        path: '/mobile/auth/index',
                        navType: 'push'
                    });
                }
            }
        }
    } else {
        next({ path: loginRoutePath, query: { redirect: to.fullPath as string }, navType: 'replaceAll' });
    }
    // next入参 false 以取消导航
    next(false);
});

export default router;
